export const formatAppLastUpdated = (lastUpdated: string): string => {
  return new Date(lastUpdated).toLocaleDateString('hu-HU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

/** Napszaknak megfelelő magyar köszönés (helyi idő szerint). */
export const getTimeOfDayGreeting = (date: Date = new Date()): string => {
  const hour = date.getHours();
  if (hour >= 5 && hour < 10) return 'Jó reggelt';
  if (hour >= 10 && hour < 12) return 'Szép napot';
  if (hour >= 12 && hour < 18) return 'Kellemes délutánt';
  return 'Szép estét';
};
